// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3GwL0","requiredAsterisk":"Info_requiredAsterisk__32in1"};